
/// <reference path="./../AbstractAboutTab.ts" />

module media.hrratings.views.about {

    import AbstractAboutTab = views.AbstractAboutTab;
    export class Board extends AbstractAboutTab {}
}
